import { State } from 'state';
import { StoreEnhancer } from 'redux';

type AnalyticsAttributes = {
  pageName?: string;
  events?: string;
  linkTrackEvents?: string;
  eVar6?: string;
  eVar9?: string;
  eVar11?: string;
  eVar12?: string;
  eVar13?: string;
  eVar14?: string;
  eVar15?: string;
  eVar17?: string;
  eVar18?: string;
  eVar19?: string;
  eVar20?: string;
  eVar21?: string;
};

export type ScanResult = {
  type: string;
  bytes: Iterable<number>;
  count: number;
  code: number;
  codes: {
    type: string;
    code: number;
  }[];
};

declare global {
  interface Window {
    Dynamic_DOM_Elements: {
      previewFrame: HTMLElement;
    };
    mwbScanner: {
      startScanning: (callBack: (result: ScanResult) => Promise<void>) => void;
      closeScanner: () => void;
    };
    __PRELOADED_STATE__?: State;
    __INITIAL_I18N_STORE__: string;
    __INITIAL_LANGUAGE__: string;

    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: (
      ...funcs: StoreEnhancer[]
    ) => StoreEnhancer;
    store?: {
      getState: () => State;
    };
    Cypress: unknown;
    s?: AnalyticsAttributes & {
      un?: string; // Analytics suite ID
      pageName?: string;
      events?: string;
      eVar6?: string;
      eVar9?: string;
      eVar11?: string;
      eVar12?: string;
      eVar13?: string;
      eVar14?: string;
      eVar15?: string;
      eVar17?: string;
      eVar18?: string;
      eVar19?: string;
      eVar20?: string;
      eVar21?: string;
      eVar22?: string;
      eVar23?: string;
      eVar24?: string;
      eVar26?: string;
      eVar27?: string;
      linkTrackVars?: string;
      t: () => void;
      tl: (
        linkObject: true | HTMLElement,
        linkType: 'o' | 'd' | 'e',
        linkName: string,
        variableOverrides?: AnalyticsAttributes,
      ) => void;
    };
    _satellite: {
      getVisitorId: () => {
        getMarketingCloudVisitorID: () => string;
      };
    };
    digitalData: {
      client: {
        clientName: string;
        pixelType: string;
      };
      page: {
        pageName: string;
      };
      application: {
        isSufficientPrefill: string;
        productChoiceSelection: string; //might make enum
        status: string; //might make enum
        consumerSearchSuccessful: string;
        coBrandOptIn: string;
        coBrandOptOut: string;
        workflow: string;
        hasAccountAssure: string;
        hasAuthBuyer: string;
      };
      enhancedPresentment: {
        epId: string;
        callId: string;
        epPlacementId: string;
        epSessionId: string;
        epMessageId: string;
        location: string;
        urlPath: string;
        embedded: string;
      };
    };
  }
}

export default (typeof window !== 'undefined' ? window : {}) as Window;
